// TODO: Move to wording repo
import React, {
  FC,
  createContext,
  useContext,
} from 'react';
import * as enWording from './en';
import * as twWording from './tw';

interface WordingProviderProps {
  lang: 'tw' | 'en';
}

export interface IWording extends FC<WordingProviderProps> {
  useWording: () => typeof twWording;
}

export const WordingContext = createContext(enWording);

const WordingProvider: IWording = ({ children, lang }) => {
  const wording = lang === 'tw' ? twWording : enWording;
  return (
    <WordingContext.Provider value={wording}>
      { children }
    </WordingContext.Provider>
  );
};

WordingProvider.useWording = () => useContext(WordingContext);

export default WordingProvider;
